import {AsyncStatusesEnum} from '../../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {AppAction} from '../../../../appActions';
import {ContactsManagerSidePanelActionsEnum} from './contactsManagerSidePanelActions';
import {ContactsManagerSidePanelState, sidePanelIsMergeContactsForm} from './contactsManagerSidePanelState';
import {ContactsManagerSidePanelTypesEnum} from './contactsManagerSidePanelStateBase';

export function contactsManagerMergeContactsReducer(
  state: ContactsManagerSidePanelState | undefined,
  action: AppAction,
): ContactsManagerSidePanelState | undefined {
  // Make sure we are only reducing on the correct state.
  if (state && !sidePanelIsMergeContactsForm(state)) {
    return state;
  }

  switch (action.type) {
    case ContactsManagerSidePanelActionsEnum.OPEN_MERGE_CONTACTS:
      return {
        type: ContactsManagerSidePanelTypesEnum.MERGE_CONTACTS,
        status: AsyncStatusesEnum.LOADING,
        cardIds: action.payload.cardIds,
        previewCardMerge: undefined,
      };
    case ContactsManagerSidePanelActionsEnum.PREVIEW_MERGE_CONTACTS: {
      if (!state) {
        return state;
      }
      return {
        ...state,
        status: AsyncStatusesEnum.LOADING,
        previewCardMerge: undefined,
      };
    }
    case ContactsManagerSidePanelActionsEnum.PREVIEW_MERGE_CONTACTS_COMPLETED: {
      if (!state) {
        return state;
      }
      return {
        ...state,
        status: AsyncStatusesEnum.LOADED,
        previewCardMerge: action.payload.previewCardMerge,
      };
    }
    case ContactsManagerSidePanelActionsEnum.PREVIEW_MERGE_CONTACTS_FAILED: {
      if (!state) {
        return state;
      }
      return {
        ...state,
        status: AsyncStatusesEnum.FAILED,
      };
    }

    default: {
      return state;
    }
  }
}
